export const firebaseConfig =
  process.env.NODE_ENV === 'production'
    ? {
        apiKey: 'AIzaSyBeeM6CMTHHVc52F6SufPYI0kvdD0cfdMU',
        authDomain: 'carsparency-46163.firebaseapp.com',
        projectId: 'carsparency-46163',
        storageBucket: 'carsparency-46163.appspot.com',
        messagingSenderId: '81897783798',
        appId: '1:81897783798:web:ef25e34737d6f7ae8207d7',
        measurementId: 'G-ZBR0E15X44',
      }
    : {
        apiKey: 'AIzaSyANSFP0bhq41zlXg36lQ08gdg6RrPOq-9o',
        authDomain: 'stage-8a96b.firebaseapp.com',
        projectId: 'stage-8a96b',
        storageBucket: 'stage-8a96b.appspot.com',
        messagingSenderId: '664517518567',
        appId: '1:664517518567:web:63ae5b99766389a4276e42',
      };
